import request from '@/request/Request'

// 登录
export function login(data) {
    return request({
        url: '/api/user/login',
        method: 'post',
        data: data
    })
}

// 更新用户信息

export function updateUserInfo(data) {
    return request({
        url: '/api/user/updateUserInfo',
        method: 'post',
        data: data
    })
}


// 退出登录
export function logout(data) {
    return request({
        url: '/api/user/logout',
        method: 'post',
        data: data
    })
}

// 最近活动
export function notice(data) {
    return request({
        url: '/api/message/notice',
        method: 'get',
        params: data
    })
}

// 未读消息
export function unread(data) {
    return request({
        url: '/api/message/unread',
        method: 'get',
        params: data
    })
}